import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { CommonButtonTypes } from 'Common/Types/Types';

export const useStyles = makeStyles<Theme, CommonButtonTypes>((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
			minWidth: 300,
			width: '95%',
			margin: '0 auto',
			fontFamily: 'Poppins',
		},
		card: {
			borderBottomLeftRadius: '3rem',
			borderBottomRightRadius: '3rem',
			borderTopLeftRadius: '100px',
			borderTopRightRadius: '100px',
			background: ({ common }) => `${common?.background ? common?.background : 'white !important'}` ,
			width: ({ common }) => `${common?.width ? common?.width : '500px'}`,
			margin: '5rem auto',
			textAlign: 'center',
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				width: '350px !important',
			},
		},
		heading: { color: '#854A4D' },
		curved: {
			position: 'relative',
			width: 'inherit',
			height: 'inherit',
			margin: '20px 0',
			borderRadius: '50% / 10%',
			borderTopLeftRadius: '100px',
			borderTopRightRadius: '100px',
			color: 'white',
			textAlign: 'center',
			fontFamily: 'Poppins',
		},
		image: {
			margin: '-8px auto',
			width: 'inherit',
			height: 'inherit',
			objectFit: 'contain',
		},
		overlap: {
			display: 'flex',
			flexDirection: 'column',
			color: 'rgba(120, 57, 61, 1)',
			alignItems: ({ common }) => `${common?.alignItems ? common?.alignItems : 'center'}`,
			fontFamily: 'Poppins',
		},
		overlapImage: {
			zIndex: 99,
			margin: '3rem auto 0',
		},
		overlapOptionImage: {
			zIndex: 9999,
			margin: '0 auto',
			top: '6rem',
			left: 0,
			position: 'absolute',
			[theme.breakpoints.down('xs')]: {
				top: '0rem',
			},
		},
		listStyle: { listStyleType: 'none' },
		overlapDiv: {
			height: ({ common }) => (common?.height ? common?.height : 'auto'),
			margin: ({ common }) => (common?.margin ? common?.margin : '1rem auto'),
			width: ({ common }) => (common?.width ? common?.width : '100%'),
			background: ({ common }) => (common?.background ? common?.background : '#FFFFFF'),
			borderRadius: ({ common }) => (common?.radius ? common?.radius : '50px'),
			borderBottomRightRadius: ({ common }) =>
				common?.borderBottomRightRadius ? common?.borderBottomRightRadius : '50px',
			borderBottomLeftRadius: ({ common }) =>
				common?.borderBottomLeftRadius ? common?.borderBottomLeftRadius : '50px',
			borderTopRightRadius: ({ common }) =>
				common?.borderTopRightRadius ? common?.borderTopRightRadius : '50px',
			borderTopLeftRadius: ({ common }) =>
				common?.borderTopLeftRadius ? common?.borderTopLeftRadius : '50px',
			overflow: 'hidden',
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				width: '100% !important',
			},
		},
		// text card
		colorChangingDiv: {
			background: ({ common }) => (common?.background ? common?.background : 'white'),
			height: ({ common }) => (common?.height ? common?.height : '290.86px'),
			borderRadius: ({ common }) => (common?.radius ? common?.radius : '5px'),
			fontFamily: 'Poppins',
		},
		numbering: {
			padding: ({ common }) => (common?.padding ? common?.padding : '1rem 1.5rem;'),
			// fontSize: '12px',
			fontFamily: 'Poppins',
			textAlign:'center',
			[theme.breakpoints.down('xs')]: {
				padding: ({ common }) => (common?.padding ? common?.padding : '.5rem 0.8rem;'),
			},
		},

		// calendar cards
		calendarBGOne: {
			background: ({ common }) => (common?.background ? common?.background : 'white'),
			width: ({ common }) => (common?.width ? common?.width : 'auto'),
			height: ({ common }) => (common?.height ? common?.height : 'auto'),
			borderTopLeftRadius: '1rem',
			borderTopRightRadius: '1rem',
			borderBottomRightRadius: '0',
			borderBottomLeftRadius: '0',
			fontFamily: 'Poppins',
		},
		budgeCalendar: {
			width: '36.82px',
			height: '53.59px',
			marginRight: '1rem',
			fontFamily: 'Poppins',
		},
		calendarBGTwo: {
			background: '#F1F6FA',
			marginTop: '.8rem',
			fontFamily: 'Poppins',
			width: ({ common }) => (common?.width ? common?.width : 'auto'),
			height: '67.48px',
			borderTopLeftRadius: '0',
			borderTopRightRadius: '0',
			borderBottomRightRadius: '1rem',
			borderBottomLeftRadius: '1rem',
		},
		inActiveDate: {
			background: '#cacaca',
			padding: '0 .2rem',
			margin: '0 .1rem',
			fontFamily: 'Poppins',
			color:'#9e9b9b'
		},
		activeDate: {
			background: '#FFED47',
			padding: '0 .2rem',
			margin: '0 .1rem',
			fontFamily: 'Poppins',
		},
		calendarCardText: {
			fontSize: '10px',
			padding: '0 .2rem',
			fontFamily: 'Poppins',
		},
		nextButton: {
			width: '49px',
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				width: '27',
			},
		},
		commonButton: {
			width: '518px',
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				width: '270.09px',
			},
		},
		headingEnlarge:{
			color: '#854A4D' , 
			fontSize:'24px'
		}
	}),
);
